export default __webpack_public_path__ + "static/media/poodlThree.11c2e9ec.jpg";